import React from 'react';
import { Link } from 'react-router-dom';
import { SetInnerHTML } from '../../../../../../UI/SetInnerHTML/SetInnerHTML';
import { SharedCategoryNavigation } from '../../../../../Shared/Content/Layouts/Widgets/CategoryNavigation/CategoryNavigation';
import FacetNavigation from '../FacetNavigation/FacetNavigation';
import { ShopSale } from '../ShopSale/ShopSale';
import { addCurrentParamsToCategoryLinkCommon } from '../../../../../../../util/addCurrentParamsToCategoryLink';
import withFacet from '../../../../../../Hooks/Shared/Facet/withFacet';

class CategoryNavigation extends SharedCategoryNavigation {
  constructor(props) {
    super(props);
    this.state = {
      categoryOpen: false,
      brandOpen: this.props.passedAppFunctions.siteFormat === 'desktop',
      showHorizCategoryNavigation: false,
      isShowHorizCategoryNavigationControl: false,
    };
    this.state.storedFacet = this.props.passedAppFunctions.getURLParamValue('facet');
    this.state.storedOrderBy = this.props.passedAppFunctions.getURLParamValue('orderBy');
    if (this.props.widgetData.categoryBrands && this.props.widgetData.categoryBrands.length > 0) {
      this.state.cachedBrandsToUse = this.props.widgetData.categoryBrands;
    } else if (this.props.facetsJSON && this.props.facetsJSON['mfName_ntk_cs']) {
      this.state.cachedBrandsToUse = this.props.facetsJSON['mfName_ntk_cs'].values;
    } else {
      this.state.cachedBrandsToUse = [];
    }
    this.state.brandsToUse = this.state.cachedBrandsToUse;
    this.state.searchTerm = '';
    this.handleBrandSearch = this.handleBrandSearch.bind(this);
    this.clearSearchTerm = this.clearSearchTerm.bind(this);
    this.categoryToggle = this.categoryToggle.bind(this);
    this.brandToggle = this.brandToggle.bind(this);
    this.categoryClicked = this.categoryClicked.bind(this);
    this.vertFacetClicked = this.vertFacetClicked.bind(this);
    this.showMoreArrows = this.showMoreArrows.bind(this);
    this.scrollCategories = this.scrollCategories.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    var returnValue = false;
    if (nextProps.passedAppFunctions.quickviewIsOpen) {
      return false;
    }
    if (nextState.searchTerm != this.state.searchTerm) {
      returnValue = true;
    }
    if (
      !_.isEqual(nextProps.passedAppFunctions.seoColorInfo, this.props.passedAppFunctions.seoColorInfo) ||
      this.props.passedAppFunctions.getURLParamValue('facet') != this.state.storedFacet
    ) {
      this.state.storedFacet = this.props.passedAppFunctions.getURLParamValue('facet');
      returnValue = true;
    }
    if (this.props.passedAppFunctions.getURLParamValue('orderBy') != this.state.storedOrderBy) {
      this.state.storedOrderBy = this.props.passedAppFunctions.getURLParamValue('orderBy');
      returnValue = true;
    }
    if (this.props.international != nextProps.international) {
      returnValue = true;
    }
    if (
      this.props.passedAppFunctions.getURLParamValue('facet')
        ? this.props.passedAppFunctions.getURLParamValue('facet').length == 0
          ? true
          : false
        : true
    ) {
      returnValue = true;
    }
    if (this.props.slotNumber === 8) {
      if (this.props.passedAppFunctions.getFeatureFlagVariation('showHorizCategoryNavigation') === 'expb') {
        returnValue = true;
      }
    }
    return returnValue || !_.isEqual(this.props.widgetData, nextProps.widgetData);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.passedAppFunctions.windowPosition != this.props.passedAppFunctions.windowPosition) {
      this.props.passedAppFunctions.setNavigationToggle('keepPos', true);
      window.scrollTo(0, this.props.passedAppFunctions.windowPosition);
    }
    // optimizely experiment wwww-21051
    if (
      this.state.showHorizCategoryNavigation === true &&
      this.props.passedAppFunctions.siteFormat == 'desktop' &&
      document.getElementById('horizCategoryNavigation') !== null
    ) {
      this.showMoreArrows();
    }
    if (
      this.state.showHorizCategoryNavigation === true &&
      prevProps.passedAppFunctions.navState !== this.props.passedAppFunctions.navState
    ) {
      const scrollElement = document.querySelector('.horizCategoriesList');
      if (scrollElement !== null) {
        scrollElement.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        if (this.props.passedAppFunctions.siteFormat == 'desktop') {
          document.getElementById('leftBtnContainer').style.display = 'none';
        }
      }
    }
  }

  componentWillUnmount() {
    if (this.props.widgetData.orientation == 'vertical') {
      this.props.passedAppFunctions.setNavigationToggle('keepPos', false);
      this.props.passedAppFunctions.setWindowPosition('windowPosition', 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      document.body.classList.remove('filter-open');
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.widgetData.categoryBrands && nextProps.widgetData.categoryBrands.length > 0) {
      this.state.cachedBrandsToUse = nextProps.widgetData.categoryBrands;
    } else if (nextProps.facetsJSON && nextProps.facetsJSON['mfName_ntk_cs']) {
      this.state.cachedBrandsToUse = nextProps.facetsJSON['mfName_ntk_cs'].values;
    } else {
      this.state.cachedBrandsToUse = [];
    }
    this.state.brandsToUse = [];
    for (var i = 0; i < this.state.cachedBrandsToUse.length; i++) {
      var thisBrand = this.state.cachedBrandsToUse[i];
      if (
        thisBrand.brandLabel &&
        thisBrand.brandLabel.replace(/\s/g, '').search(new RegExp(this.state.searchTerm.replace(/\s/g, ''), 'i')) > -1
      ) {
        this.state.brandsToUse.push(thisBrand);
      }
      if (
        thisBrand.dsp &&
        thisBrand.dsp.replace(/\s/g, '').search(new RegExp(this.state.searchTerm.replace(/\s/g, ''), 'i')) > -1
      ) {
        this.state.brandsToUse.push(thisBrand);
      }
    }
    this.setState({});
  }
  handleBrandSearch(event) {
    var newSearchTerm = event.target.value;
    //filter brands based on search term
    this.state.brandsToUse = [];
    for (var i = 0; i < this.state.cachedBrandsToUse.length; i++) {
      var thisBrand = this.state.cachedBrandsToUse[i];
      if (
        thisBrand.brandLabel &&
        thisBrand.brandLabel.replace(/\s/g, '').search(new RegExp(newSearchTerm.replace(/\s/g, ''), 'i')) > -1
      ) {
        this.state.brandsToUse.push(thisBrand);
      }
      if (
        thisBrand.dsp &&
        thisBrand.dsp.replace(/\s/g, '').search(new RegExp(newSearchTerm.replace(/\s/g, ''), 'i')) > -1
      ) {
        this.state.brandsToUse.push(thisBrand);
      }
    }
    this.setState({ searchTerm: newSearchTerm });
  }
  vertFacetClicked(thisBrand) {
    this.props.passedAppFunctions.setWindowPosition('windowPosition', window.pageYOffset);
    var facetBreadcrumbForTracking = this.props.widgetData.facetBreadcrumbForTracking;
    var isFacetAlreadySelected = this.props.isFacetSelected(thisBrand.val);
    if (facetBreadcrumbForTracking && !isFacetAlreadySelected) {
      try {
        //adobe tracking
        window.trackFacetUsage('brand', thisBrand.dsp);
      } catch (err) {}
    }
  }
  clearSearchTerm(event) {
    this.state.brandsToUse = JSON.parse(JSON.stringify(this.state.cachedBrandsToUse));
    this.setState({ searchTerm: '' });
  }
  generateNewArrivalsLink(facetValue) {
    var returnLink = this.props.passedAppFunctions.routeInfo.location.pathname.split('?')[0];
    var search = this.props.passedAppFunctions.routeInfo.location.search || '';
    if (search.includes('&forceFlatResults=true')) {
      search = search.replace('forceFlatResults=true', '');
    }
    if (search.includes('forceFlatResults=forceFlatResults')) {
      search = search.replace('forceFlatResults=forceFlatResults', '');
    }
    if (this.props.passedAppFunctions.routeInfo.location.pathname.indexOf('?') > -1) {
      search = '?' + this.props.passedAppFunctions.routeInfo.location.pathname.split('?').splice(1).join('?');
    }
    return this.props.passedAppFunctions.updateUrlWithParams(returnLink + search, {
      facet: facetValue,
      pageNumber: false,
    });
  }
  addCurrentParamsToCategoryLink(inputUrl) {
    return addCurrentParamsToCategoryLinkCommon(inputUrl, this.props);
  }

  categoryToggle() {
    if (this.props.passedAppFunctions.siteFormat == 'tablet') {
      this.setState({ categoryOpen: !this.state.categoryOpen });
    }
  }
  brandToggle() {
    if (this.props.passedAppFunctions.siteFormat == 'tablet') {
      this.setState({ brandOpen: !this.state.brandOpen });
      this.forceUpdate();
    }
  }
  categoryClicked() {
    this.props.passedAppFunctions.siteFormat == 'tablet' ? (this.props.toggleFacetMenu(), this.categoryToggle()) : '';
  }
  thisFacetClicked = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.target.parentNode.lastChild.click();
    }
  };

  // optimizely experiment wwww-21051
  componentDidMount() {
    this.setState({
      showHorizCategoryNavigation:
        this.props.passedAppFunctions.getFeatureFlagVariation('showHorizCategoryNavigation') === 'expb',
      isShowHorizCategoryNavigationControl:
        this.props.passedAppFunctions.getFeatureFlagVariation('showHorizCategoryNavigation') === 'expa',
    });
    if (this.props.passedAppFunctions.siteFormat === 'desktop') {
      this.setState({ brandOpen: true });
    }
  }

  showMoreArrows() {
    const scrollWidth = document.querySelector('.horizCategoriesList').scrollWidth;
    const scrollWrapWidth = document.querySelector('#horizScrollWrapper').offsetWidth;
    if (scrollWidth > scrollWrapWidth) {
      document.getElementById('rightBtnContainer').style.display = 'block';
    } else {
      document.getElementById('rightBtnContainer').style.display = 'none';
      document.getElementById('leftBtnContainer').style.display = 'none';
    }
  }

  scrollCategories(e) {
    const buttonClicked = e.target;
    const scrollElement = document.querySelector('.horizCategoriesList');
    const scrollAmount = scrollElement.offsetWidth;
    if (buttonClicked.id === 'right') {
      scrollElement.scrollLeft += scrollAmount;
      buttonClicked.offsetParent.style.display = 'none';
      document.getElementById('leftBtnContainer').style.display = 'block';
    }
    if (buttonClicked.id === 'left') {
      scrollElement.scrollLeft -= scrollAmount;
      buttonClicked.offsetParent.style.display = 'none';
      document.getElementById('rightBtnContainer').style.display = 'block';
    }
  }

  render() {
    const {
      international,
      personalization,
      isFacetSelected,
      justForYouChecked,
      generateLinkForFacet,
      generateLinkForFacetJustForYou,
      shouldShowJustForYou,
    } = this.props;
    var widgetData = this.props.widgetData;
    return (
      <>
        {this.props.slotNumber === 8 ? (
          this.state.showHorizCategoryNavigation === true &&
          this.props.resultListIsPresent === 'true' &&
          widgetData.categories &&
          widgetData.categories.length > 0 &&
          (!widgetData.isLeafLevel || widgetData.isLeafLevel !== 'true') ? (
            <div id='horizCategoryNavigation'>
              {this.props.passedAppFunctions.siteFormat === 'desktop' ? (
                <div id='leftBtnContainer' tabIndex={-1}>
                  <button type='button' id='left' onClick={this.scrollCategories} />
                </div>
              ) : (
                ''
              )}
              <div id='horizScrollWrapper'>
                <ul className='horizCategoriesList'>
                  <li>
                    <div className='listAll'>All</div>
                  </li>
                  {widgetData.categories.map((thisCategory, index) => (
                    <li
                      data-leftnavlink={this.addCurrentParamsToCategoryLink(thisCategory.categoryLink)}
                      key={index + '' + thisCategory.categoryValue}
                    >
                      <Link
                        manual_cm_sp={thisCategory.manualCmSp}
                        rel={
                          this.addCurrentParamsToCategoryLink(thisCategory.categoryLink).indexOf('?') > -1
                            ? 'nofollow'
                            : undefined
                        }
                        to={this.addCurrentParamsToCategoryLink(thisCategory.categoryLink)}
                      >
                        <div>
                          <SetInnerHTML innerHTML={thisCategory.categoryLabel} />
                        </div>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              {this.props.passedAppFunctions.siteFormat === 'desktop' ? (
                <div id='rightBtnContainer' tabIndex={-1}>
                  <button type='button' id='right' onClick={this.scrollCategories} />
                </div>
              ) : (
                ''
              )}
            </div>
          ) : (
            ''
          )
        ) : (
          <div className='CategoryNavigation'>
            <div>
              {(!this.props.newArrivalsWidgetIsPresent && this.props.facetsJSON.dil_newArrival) ||
              (!this.props.newArrivalsWidgetIsPresent && personalization && shouldShowJustForYou) ||
              (!this.props.newArrivalsWidgetIsPresent && shouldShowJustForYou) ? (
                <fieldset>
                  {(!this.props.newArrivalsWidgetIsPresent && personalization && shouldShowJustForYou) ||
                  (!this.props.newArrivalsWidgetIsPresent && shouldShowJustForYou) ? (
                    <>
                      <legend className='sr-only'>Just For You</legend>
                      <ul className='facet facet-header no-style'>
                        <li id='justForYouChkBox' className='ShopNewArrivals'>
                          <div className='custom-control custom-checkbox d-inline-block mr-2'>
                            <input
                              className='custom-control-input'
                              type='checkbox'
                              role='checkbox'
                              readOnly
                              aria-checked={justForYouChecked}
                              checked={justForYouChecked}
                              onKeyUp={this.thisFacetClicked}
                              aria-labelledby='justForYouChkBox'
                            ></input>
                            <label
                              className='custom-control-label-nocolor custom-control-label'
                              htmlFor='justForYouChkBox'
                              onClick={(e) => e.target.nextElementSibling.click()}
                            >
                              <span className='sr-only'>Just For You</span>
                            </label>
                            <Link suppressHydrationWarning={true} to={generateLinkForFacetJustForYou()} tabIndex='-1'>
                              Just For You
                            </Link>
                          </div>
                          {!international && (
                            <Link
                              to={'/my-preferences'}
                              tabIndex='-1'
                              id='justForYouEditMyPreferences'
                              className='btn-tertiary d-inline p-0'
                            >
                              (Edit)
                            </Link>
                          )}
                        </li>
                      </ul>
                    </>
                  ) : null}
                  {!this.props.newArrivalsWidgetIsPresent &&
                  this.props.facetsJSON.dil_newArrival &&
                  personalization &&
                  shouldShowJustForYou ? (
                    <>
                      <legend className='sr-only'>New Arrivals</legend>
                      <ul className='facet facet-header no-style'>
                        <li id='newArrivalsChkBox' className='ShopNewArrivals'>
                          <div className='custom-control custom-checkbox'>
                            <input
                              className='custom-control-input'
                              id='newArrivalsChkBox'
                              checked={isFacetSelected(this.props.facetsJSON.dil_newArrival.values[0].val)}
                              readOnly
                              type='checkbox'
                              role='checkbox'
                              aria-checked={isFacetSelected(this.props.facetsJSON.dil_newArrival.values[0].val)}
                              onKeyUp={this.thisFacetClicked}
                              aria-labelledby='newArrivalsChkBox'
                            />
                            <label
                              className='custom-control-label-nocolor custom-control-label'
                              htmlFor='newArrivalsChkBox'
                              onClick={(e) => e.target.nextElementSibling.click()}
                            >
                              <span className='sr-only'>New Arrivals</span>
                            </label>
                            <Link
                              to={this.generateNewArrivalsLink(this.props.facetsJSON.dil_newArrival.values[0].val)}
                              manual_cm_sp={this.props.widgetData.newArrivals_manualCmSp}
                              tabIndex='-1'
                            >
                              New Arrivals
                            </Link>
                          </div>
                        </li>
                      </ul>
                    </>
                  ) : null}
                </fieldset>
              ) : null}
              {!this.props.shopSaleWidgetIsPresent && (
                <ShopSale passedAppFunctions={this.props.passedAppFunctions} {...this.props} />
              )}
            </div>
            {widgetData.categories &&
            widgetData.categories.length > 0 &&
            (!widgetData.isLeafLevel || widgetData.isLeafLevel !== 'true') ? (
              <React.Fragment>
                <div className='filter-list'>
                  <h3
                    className={`${
                      this.props.passedAppFunctions.siteFormat == 'tablet' && this.state.categoryOpen ? 'open' : ''
                    } facet-title`}
                    onClick={this.categoryToggle}
                  >
                    Category
                  </h3>
                  <ul className='facet'>
                    {widgetData.categories.map((thisCategory, index) => (
                      <li
                        data-leftnavlink={this.addCurrentParamsToCategoryLink(thisCategory.categoryLink)}
                        key={index + '' + thisCategory.categoryValue}
                        onClick={this.categoryClicked}
                      >
                        <Link
                          manual_cm_sp={thisCategory.manualCmSp}
                          rel={
                            this.addCurrentParamsToCategoryLink(thisCategory.categoryLink).indexOf('?') > -1
                              ? 'nofollow'
                              : undefined
                          }
                          to={this.addCurrentParamsToCategoryLink(thisCategory.categoryLink)}
                        >
                          <div>
                            <SetInnerHTML innerHTML={thisCategory.categoryLabel} />
                          </div>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </React.Fragment>
            ) : (
              ''
            )}
            {this.state.cachedBrandsToUse.length > 1 && (
              <div className='filter-list'>
                <div className='vert-facets'>
                  <h3 className={`${this.state.brandOpen ? 'open' : ''} facet-title`} onClick={this.brandToggle}>
                    Brand
                  </h3>
                  {this.state.brandOpen && (
                    <>
                      <div className='searchByBrandFilterWrapper'>
                        <label htmlFor='searchByBrandFilterInput' className='sr-only'>
                          Search by brand
                        </label>
                        <input
                          id='searchByBrandFilterInput'
                          placeholder='Search by brand...'
                          type='text'
                          autoComplete='off'
                          autoCorrect='off'
                          spellCheck='false'
                          aria-describedby='searchByBrandFilterInputSROnly'
                          value={this.state.searchTerm}
                          onChange={this.handleBrandSearch}
                        />
                        {this.state.searchTerm ? (
                          <span onClick={this.clearSearchTerm} className='btnWrapper'>
                            <button id='clearBrandSearchBtn'>
                              <svg
                                className='clearBrand'
                                height='15'
                                width='15'
                                xmlns='http://www.w3.org/2000/svg'
                                viewBox='0 0 48.77 48.77'
                                role='img'
                                aria-labelledby='clearBrandSearch'
                              >
                                <title id='clearBrandSearch'>Clear Brand Search Term</title>
                                <g data-name='Layer 2'>
                                  <g data-name='Layer 1'>
                                    <path d='M25.8,24.39,48.48,1.71A1,1,0,0,0,47.07.29L24.39,23,1.71.29A1,1,0,0,0,.29,1.71L23,24.39.29,47.07a1,1,0,1,0,1.41,1.41L24.39,25.8,47.07,48.48a1,1,0,0,0,1.41-1.41Z' />
                                  </g>
                                </g>
                              </svg>
                            </button>
                          </span>
                        ) : (
                          <span>
                            <svg height='15' width='15' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48.92 47.58'>
                              <title>search</title>
                              <g data-name='Layer 2'>
                                <g data-name='Layer 1'>
                                  <path d='M48.6,45.85,32.28,30.5a18.56,18.56,0,1,0-1.4,1.43L47.23,47.31a1,1,0,1,0,1.37-1.46ZM2,18.42A16.42,16.42,0,1,1,18.42,34.83,16.44,16.44,0,0,1,2,18.42Z' />
                                </g>
                              </g>
                            </svg>
                          </span>
                        )}
                      </div>
                      <fieldset>
                        <legend className='sr-only'>Brand</legend>
                        <ul className='facet'>
                          {this.state.brandsToUse.map((thisBrand) => (
                            <li
                              key={thisBrand.dsp + thisBrand.brandLabel}
                              className={`${thisBrand.dsp ? 'custom-control custom-checkbox' : 'facet-link'}`}
                            >
                              {thisBrand.dsp ? (
                                <>
                                  <input
                                    className='custom-control-input'
                                    readOnly
                                    checked={isFacetSelected(thisBrand.val)}
                                    onKeyUp={this.thisFacetClicked}
                                    type='checkbox'
                                    role='checkbox'
                                    aria-checked={isFacetSelected(thisBrand.val)}
                                    id={thisBrand.val}
                                    tabIndex='0'
                                  />
                                  <label
                                    className='custom-control-label-nocolor custom-control-label'
                                    htmlFor={thisBrand.val}
                                    onClick={(e) => e.target.nextElementSibling.click()}
                                  >
                                    <span className='sr-only'>{thisBrand.dsp}</span>
                                  </label>
                                  <Link
                                    onClick={() => this.vertFacetClicked(thisBrand)}
                                    rel='nofollow'
                                    to={generateLinkForFacet(thisBrand.val)}
                                    tabIndex='-1'
                                  >
                                    {thisBrand.dsp}
                                  </Link>
                                </>
                              ) : (
                                <Link to={thisBrand.brandLink}>
                                  <span>
                                    <SetInnerHTML innerHTML={thisBrand.brandLabel} />
                                  </span>
                                </Link>
                              )}
                            </li>
                          ))}
                        </ul>
                      </fieldset>
                    </>
                  )}
                </div>
              </div>
            )}
            {this.props.passedAppFunctions.siteFormat === 'desktop' && (
              <div>
                <FacetNavigation
                  widgetData={widgetData}
                  passedAppFunctions={this.props.passedAppFunctions}
                  facetsJSON={this.props.facetsJSON}
                  facetsInCatNav={true}
                  excludeFacets={this.props.excludeFacets}
                />
              </div>
            )}
            <script
              type='application/ld+json'
              suppressHydrationWarning={true}
              dangerouslySetInnerHTML={{ __html: JSON.stringify(this.buildStructuredData(widgetData.categories)) }}
            ></script>
          </div>
        )}
      </>
    );
  }
}

export default withFacet(CategoryNavigation);
